import React from 'react';
import { getTranslatedText } from '../helpers/CheckTranslations';
import { store } from '../redux/store';

const Fail = () => {

    return <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 100,
    }}>
        <span>{getTranslatedText('paymentFailed', store)}</span>
    </div>
}

export default Fail